// import React from 'react'
// import { toast } from 'react-hot-toast';
// import { Link, NavLink } from 'react-router-dom'
// import { useAuth } from '../../context/auth'

// const Header = () => {
//     const [auth, setAuth] = useAuth();
//     const handleLogout = () => {
//         setAuth({
//             ...auth, user: null, token: '',
//         });
//         localStorage.removeItem("auth");
//         toast.success("Logout successfully...")
//     }
//     return (
//         <>
//             <nav className="navbar navbar-expand-lg bg-body-tertiary">
//                 <div className="container-fluid">
//                     <Link className="navbar-brand" to="/">Navbar</Link>
//                     <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//                         <span className="navbar-toggler-icon" />
//                     </button>
//                     <div className="collapse navbar-collapse" id="navbarSupportedContent">
//                         <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
//                             <li className="nav-item">
//                                 <NavLink className="nav-link " aria-current="page" to="/">Home</NavLink>
//                             </li>
//                             {
//                                 !auth.user ? (
//                                     <>
//                                         <li className="nav-item">
//                                             <NavLink className="nav-link" to="/register">REGISTER</NavLink>
//                                         </li>

//                                         <li className="nav-item">
//                                             <NavLink className="nav-link " to="/login">LOGIN</NavLink>
//                                         </li>

//                                     </>
//                                 ) : (<>
//                                     <li className="nav-item">
//                                         <NavLink onClick={handleLogout} className="nav-link " to="/login">LOGOUT</NavLink>
//                                     </li>
//                                 </>)
//                             }
//                             <li className="nav-item">
//                                 <NavLink className="nav-link" to="/cart">CART(0)</NavLink>
//                             </li>
//                         </ul>
//                         <form className="d-flex" role="search">
//                             <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
//                             <button className="btn btn-outline-success" type="submit">Search</button>
//                         </form>
//                     </div>
//                 </div>
//             </nav>

//         </>
//     )
// }

// export default Header



import React from "react";
import { NavLink, Link } from "react-router-dom";
import { useAuth } from "../../context/auth";
import toast from "react-hot-toast";
import { useCart } from "../../context/cart";
import logo from '../../assets/bablu_logo.png'

const Header = () => {
  const [auth, setAuth] = useAuth();
  const [cart] = useCart();
  const handleLogout = () => {
    setAuth({
      ...auth,
      user: null,
      token: "",
    });
    localStorage.removeItem("auth");
    toast.success("Logout Successfully");
  };
  return (
    <div className="navbar_content" style={{}}>
      <nav className="navbar homeNavbar navbar-expand-lg  "style={{background:'#eee'}}>
        <div className="container-fluid" style={{background:'#eee'}}>
      <Link to="/" className="navbar-brand" style={{color:"#30ABE2",fontWeight:"bolder"}}>
              <img src={logo} alt="logo" height='55px' width='55px' style={{marginLeft:'15px'}} />
            </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo01"
            aria-controls="navbarTogglerDemo01"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
           
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink to="/" className="nav-link ">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/category" className="nav-link ">
                  Category
                </NavLink>
              </li>
              {!auth?.user ? (
                <>
                  <li className="nav-item">
                    <NavLink to="/register" className="nav-link">
                      Register
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/login" className="nav-link">
                      Login
                    </NavLink>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item dropdown">
                    <NavLink
                      className="nav-link dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {auth?.user?.name}
                    </NavLink>
                    <ul className="dropdown-menu">
                      <li>
                        <NavLink
                          to={`/dashboard/${
                            auth?.user?.role === 1 ? "admin" : "user"
                          }`}
                          className="dropdown-item"
                        >
                          Dashboard
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          onClick={handleLogout}
                          to="/login"
                          className="dropdown-item"
                        >
                          Logout
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </>
              )}
              <li className="nav-item">
                <NavLink to="/cart" className="nav-link">
                  Cart {cart?.length}
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <Badge count={cart?.length} showZero style={{color:'white'}}>
                  <NavLink to="/cart" className="nav-link">
                    Cart
                  </NavLink>
                </Badge>
              </li> */}
              {/* <li className="nav-item">
                <IconButton aria-label="cart">
                    <StyledBadge count={4} color="secondary">
                           <ShoppingCartIcon /> 
                          cart
                    </StyledBadge>
                </IconButton>
              </li> */}
              
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header; 